import { render, staticRenderFns } from "./ModalContactReason.vue?vue&type=template&id=065b31fc&scoped=true&"
import script from "./ModalContactReason.vue?vue&type=script&lang=js&"
export * from "./ModalContactReason.vue?vue&type=script&lang=js&"
import style0 from "./ModalContactReason.vue?vue&type=style&index=0&id=065b31fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b31fc",
  null
  
)

export default component.exports